const PreviewImage = ({ label, src }) => (
    <div>
        <div className="text-xs text-gray-500 mb-2">
            {label}
        </div>

        {src ? (
            <img
                src={src}
                alt={label}
                className="max-h-40 rounded-lg border p-2 object-contain"
            />
        ) : (
            <div className="h-32 rounded-lg border border-dashed flex items-center justify-center text-gray-400">
                Tidak ada gambar
            </div>
        )}
    </div>
);

export default PreviewImage;